
	<a
		class="bx--link bx--tile bx--tile--clickable"
		[ngClass]="{
			'bx--tile--is-clicked': clicked
		}"
		tabindex="0"
		(click)="onClick($event)"
		(keydown)="onKeyDown($event)"
		[href]="href"
		[attr.aria-disabled]="disabled">
		<ng-content></ng-content>
	</a>